import React, { FC } from 'react'
import { Field, Form } from 'formik'
import { t } from '@lingui/macro'
import { FormikProps } from 'formik'
import { SignupSecondStepValues } from 'pages/native/onBoarding/types/types'
import {
  FormCheckbox,
  Button,
  FormInput,
  NextIcon
} from 'pages/native/onBoarding/components'
import styles from './SignupSecondStepForm.module.scss'

interface Props {
  formik: FormikProps<SignupSecondStepValues>
  //onBackToLogin: () => void
}

export const SignupSecondStepForm: FC<Props> = ({ formik }) => {
  return (
    <Form>
      <div className={styles.FormContainer}>
        <div className={styles.FormFields}>
          {/* Here we need to add more logic: check if email already exists, get the BE endpoint */}
          <Field
            component={FormInput}
            id="email"
            name="email"
            label={t`Email`}
            placeholder={t`Eg: john@email.com`}
            type="email"
            isRequired
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
              e.target.value = e.target.value.trim()
              formik.handleBlur(e)
            }}
            isValid={!(formik.touched.email && formik.errors.email)}
            validationMessage={formik.errors.email}
          />

          <Field
            component={FormInput}
            id="confirmEmail"
            name="confirmEmail"
            label={t`Confirm email`}
            placeholder={t`Eg: john@email.com`}
            type="email"
            isRequired
            value={formik.values.confirmEmail}
            onChange={formik.handleChange}
            onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
              e.target.value = e.target.value.trim()
              formik.handleBlur(e)
            }}
            isValid={
              !(formik.touched.confirmEmail && formik.errors.confirmEmail)
            }
            validationMessage={formik.errors.confirmEmail}
          />

          <Field
            component={FormInput}
            id="password"
            name="password"
            label={t`Password`}
            placeholder={t`Enter your password`}
            type="password"
            value={formik.values.password}
            isRequired
            showTogglePassword
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            isValid={!(formik.touched.password && formik.errors.password)}
            validationMessage={formik.errors.password}
          />

          <Field
            component={FormInput}
            id="confirmPassword"
            name="confirmPassword"
            label={t`Confirm password`}
            placeholder={t`Enter your password again`}
            type="password"
            value={formik.values.confirmPassword}
            isRequired
            showTogglePassword
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            isValid={
              !(formik.touched.confirmPassword && formik.errors.confirmPassword)
            }
            validationMessage={formik.errors.confirmPassword}
          />

          <div className={styles.CheckboxContainer}>
            <Field name="privacyPolicyChecked">
              {({ field, form }: any) => (
                <FormCheckbox
                  id="privacyPolicyChecked"
                  name="privacyPolicyChecked"
                  field={field}
                  form={form}
                  isRequired
                  label={
                    <>
                      {t`I have read and accept `}&nbsp;
                      <a
                        href="https://www.solidsport.com/sv/privacy-policy/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.ClickableText}
                      >
                        {t`Solidsport's terms of use.`}
                      </a>
                    </>
                  }
                />
              )}
            </Field>

            <Field name="emailConsent">
              {({ field, form }: any) => (
                <FormCheckbox
                  id="emailConsent"
                  name="emailConsent"
                  field={field}
                  form={form}
                  label={t`I want to receive Solidsport event and offer updates.`}
                />
              )}
            </Field>
          </div>
        </div>

        <div className={styles.ButtonsContainer}>
          <Button
            type="submit"
            label={t`Next`}
            icon={<NextIcon />}
            iconPosition="right"
            variant="filled"
            theme="primary"
            disabled={formik.isSubmitting || !formik.isValid || !formik.dirty}
          />
        </div>
      </div>
    </Form>
  )
}
